export default {
  name: 'marking--docEaeuShipment',
  urlParamName: 'marking--docEaeuShipment',
};
